import React, { useState, useEffect } from 'react';
import Navbar from './Navbar'
import './Algorithms.css'
import { Link } from 'react-router-dom'
import { auth, database } from './firebase';
import logo from './images/semicolon.png'

function Algorithms() {

  const [loggedIn, setLoggedIn] = useState(false);
  const [userQuestions, setUserQuestions] = useState([]);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        setLoggedIn(true);
        fetchUserQuestions(user.uid);
      } else {
        setLoggedIn(false);
      }
    });

    return unsubscribe()
  }, [auth]);

  const fetchUserQuestions = (userId) => {
    const userRef = database.ref('users').child(userId).child('questions');
    userRef.on('value', (snapshot) => {
      const questionsData = snapshot.val();
      if (questionsData) {
        const questionsArray = Object.values(questionsData);
        setUserQuestions(questionsArray);
      }
    });
  };

  return (
    <div className='algorithms-container'>
        <Navbar />
        <div className='logo-container'>
          <Link to='/'>
          <img src={logo} className='logo' alt='logo' />
          </Link>
        </div>
        <div className='message'>
          <h1>
            SORRY !
          </h1>
          <p>
          Dear mobile user, we know you like convenience, but trust us when we say the desktop experience of this web app will blow your tiny mobile mind. Don't settle for less switch to desktop view and unleash your awesome powers!
          </p>
        </div>
        {loggedIn ? (
        <div className='algo-hide'>
          <div className='algo_tb'>
              <p>Problem</p>
              <p>Difficulty</p>
          </div>
          <div className='prob_diff'>
              <div className='algorithms'>
                  <Link to='/problems/reverse-a-string' className='link-style'>
                    <p className={`link-style ${userQuestions.find((question) => question.title === 'Reverse a String') ? 'submitted' : ''}`}>Reverse a String</p>
                  </Link>
                  <Link to='/problems/sum-of-two' className='link-style'>
                    <p className={`link-style ${userQuestions.find((question) => question.title === 'Sum of Two Numbers') ? 'submitted' : ''}`}>Sum of Two Numbers</p>
                  </Link>
                  <Link to='/problems/palindrome' className='link-style'>
                    <p className={`link-style ${userQuestions.find((question) => question.title === 'Palindrome Check') ? 'submitted' : ''}`}>Palindrome Check</p>
                  </Link>
                  <Link to='/problems/fizzbuzz' className='link-style'>
                    <p className={`link-style ${userQuestions.find((question) => question.title === 'FizzBuzz') ? 'submitted' : ''}`}>FizzBuzz</p>
                  </Link>
                  <Link to='/problems/counting' className='link-style'>
                    <p className={`link-style ${userQuestions.find((question) => question.title === 'Counting Elements') ? 'submitted' : ''}`}>Counting Elements</p>
                  </Link>
                  <Link to='/problems/long-comm-sub' className='link-style'>
                    <p className={`link-style ${userQuestions.find((question) => question.title === 'Longest Common Subsequence') ? 'submitted' : ''}`}>Longest Common Subsequence</p>
                  </Link>
                  <Link to='/problems/merge-intervals' className='link-style'>
                    <p className={`link-style ${userQuestions.find((question) => question.title === 'Merge Intervals') ? 'submitted' : ''}`}>Merge Intervals</p>
                  </Link>
                  <Link to='/problems/bt-max' className='link-style'>
                    <p className={`link-style ${userQuestions.find((question) => question.title === 'Binary Tree Maximum Path Sum') ? 'submitted' : ''}`}>Binary Tree Maximum Path Sum</p>
                  </Link>
                  <Link to='/problems/sudoku' className='link-style'>
                    <p className={`link-style ${userQuestions.find((question) => question.title === 'Sudoku Solver') ? 'submitted' : ''}`}>Sudoku Solver</p>
                  </Link>
                  <Link to='/problems/short-path-dg' className='link-style'>
                    <p className={`link-style ${userQuestions.find((question) => question.title === 'Shortest Path in a Directed Graph') ? 'submitted' : ''}`}>Shortest Path in a Directed Graph</p>
                  </Link>
              </div>
              <div className='diff'>
                  <p>Easy</p>
                  <p>Easy</p>
                  <p>Easy</p>
                  <p>Easy</p>
                  <p>Easy</p>
                  <p>Medium</p>
                  <p>Medium</p>
                  <p>Medium</p>
                  <p>Hard</p>
                  <p>Hard</p>
              </div>
          </div>
        </div>
        ) : (
          <div>
            <h2>Please sign up/login to see this page</h2>
          </div>
        )}
    </div>
  )
}

export default Algorithms